
window.bssB2BHooks = window.bssB2BHooks || {
    actions: {},
    filters: {},
};

window.BSS_B2B = window.BSS_B2B || {};

window.BSS_B2B.addAction = (tag, callback) => {
    window.bssB2BHooks.actions[tag] = callback;
}
window.BSS_B2B.addFilter = (tag,  value) => {
    window.bssB2BHooks.filters[tag] = value;
}
        
//Clone checkout 
if (!window.findFirstMatchingElement) {
    // Lặp qua từng thành phần trong selector, trả về phần tử đầu tiên tìm thấy
    window.findFirstMatchingElement = (selectorsString) => {
        const selectors = selectorsString.split(',').map(s => s.trim());
        for (const selector of selectors) {
            const element = document.querySelector(selector);
            if (element) return element;
        }
        return null;
    }
}

const STYLE_ID = "disable-checkout-style";
const selectorCheckout = `[name='checkout']:not(.bss-checkout), [href='/checkout']:not(.bss-checkout), .go-cart__button:not(.bss-checkout), .qsc2-checkout-button:not(.bss-checkout), .button-checkout:not(.bss-checkout)`;
const selectorCheckoutBSS = `.bss-checkout`;

// document.addEventListener('click', function (event) {
//     const clickedElement = event.target;
//     const isInsideBSSCheckout = clickedElement.closest(selectorCheckoutBSS);
//     if (isInsideBSSCheckout) {
//         setTimeout(() => {
//             const oldCheckout = window.findFirstMatchingElement(selectorCheckout);
//             if (oldCheckout) {
//                 oldCheckout.click();
//             }
//         }, 3000);
//     }
// });

function addDisableCheckoutStyle() {
    if (!document.getElementById(STYLE_ID)) {
        const style = document.createElement("style");
        style.id = STYLE_ID;
        style.textContent = `
              ${selectorCheckout} {
                pointer-events: none !important;
                opacity: 0.6 !important;
              }
            `;
        document.head.appendChild(style);
    }
}

function removeDisableCheckoutStyle() {
    const style = document.getElementById(STYLE_ID);
    if (style) {
        style.remove();
    }
}

document.addEventListener("bss_b2b:CustomCartUpdate", e => {
    addDisableCheckoutStyle();
    setTimeout(() => {
      BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
    }, 1000);
    setTimeout(() => {
      BSS_B2B?.observer?.cartSubject?.listenCartCheckout?.();
    }, 2000);
});

addDisableCheckoutStyle()

function cloneButtonWithStyles(originalButton) {
    const clone = originalButton.cloneNode(true);
    const computedStyles = window.getComputedStyle(originalButton);
    for (let i = 0; i < computedStyles.length; i++) {
        const propName = computedStyles[i];
        clone.style.setProperty(propName, computedStyles.getPropertyValue(propName));
    }
    return clone;
}

let watchClassCheckout = false;
function handleWatchClassCheckout(targets) {
    if (watchClassCheckout) return;
    watchClassCheckout = true;
    targets.forEach(target => {
        const observer = new MutationObserver(mutations => {
            mutations.forEach(mutation => {
                if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
                    const allowedClass = 'bss-checkout';
                    const currentClasses = Array.from(target.classList);
                    if (currentClasses.length > 1 || !target.classList.contains(allowedClass)) {
                        target.className = allowedClass;
                    }
                }
            });
        });
        observer.observe(target, {
            attributes: true,
            attributeFilter: ['class'],
            attributeOldValue: true
        });
    })
}

function fixCheckoutBtnSelector() {
    const defaultButtons = document.querySelectorAll(selectorCheckout);
    console.log("defaultButtons",defaultButtons)
    defaultButtons.forEach((btn) => {
        const parent = btn.parentNode;
        if (parent.querySelector(".bss-checkout")) return;
        const customCheckout = cloneButtonWithStyles(btn);
        customCheckout.classList = "bss-checkout";
        customCheckout.removeAttribute("name");
        customCheckout.removeAttribute("form");
        customCheckout.removeAttribute("id");
        customCheckout.removeAttribute("href");
        customCheckout.removeAttribute("onclick");
        customCheckout.onclick = null;
        customCheckout.type = "button";
        customCheckout.innerHTML = btn.innerHTML;
        btn.parentNode.insertBefore(customCheckout, btn.nextSibling);
        Object.assign(btn.style, {
            display: "none",
            visibility: "hidden",
            opacity: "0",
            pointerEvents: "none",
            position: "absolute"
        });
        Object.assign(customCheckout.style, {
            display: "inline-block",
            visibility: "visible",
            opacity: "1",
            pointerEvents: "unset"
        });
    });
    removeDisableCheckoutStyle();
    const cloneCheckout = document.querySelectorAll(selectorCheckoutBSS)
    handleWatchClassCheckout(cloneCheckout);
    document.dispatchEvent(new Event("KC:cloneCheckoutDone"))
    return cloneCheckout;
}

window.BSS_B2B.addFilter('custom:cart/checkout_ele', fixCheckoutBtnSelector);

function handle_redirect_checkout() {
      // const checkoutBtn = document.querySelector(selectorCheckout);
      // console.log({checkoutBtn})
      // if (checkoutBtn) {
      //     checkoutBtn.click()
      // }
      window.location.href = '/checkout';
      return true;
}

window.BSS_B2B.addFilter('custom:redirect/checkout', handle_redirect_checkout);




if (typeof BSS_B2B != undefined) {
  setTimeout (() =>{
    const targetCart = document.querySelector("#cart-drawer");
    if (targetCart) {
      const mutationObserver = new MutationObserver((recordList, observe) => {
        BSS_B2B.dc?.utils.init();
        BSS_B2B.observer.cartSubject.listenCartCheckout();
      });
      mutationObserver.observe(targetCart, { attributes: true });
    }
  }, 1500)
}

const miniCart = document.querySelector('.bss-b2b-mini-cart.cart-drawer');
        
BSS_BCP.nt.isEnable = false;
if (miniCart) {
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
            if (m.target.classList.contains("is-open")) {
                // document.querySelectorAll(".bss-b2b-customer-portal-share-cart-btn").forEach((button) => button.remove());
                // document.querySelectorAll(".bss-b2b-customer-portal-nt-checkout-btn").forEach((button) => button.remove())
                // BSS_BCP.ca.addShareCartBtnToCheckoutButtons(document.querySelectorAll('div#cart-drawer button[type="submit"]'))
                // BSS_BCP.netterm.showButtonOnCartPage();

                BSS_B2B.nt.initFunction()
                document.dispatchEvent(new Event("DOMContentLoaded"));
            }
        });
    });
    observer.observe(miniCart, { attributes: true });
}

if (window.location.pathname.endsWith("/apps/customer-portal") && window.BSS_BCP?.shopData?.customer && !BSS_BCP.shopData.customer.id) {
    const formObserver = new MutationObserver(function () {
        const loginForm = document.querySelector("#customer_login");
        if (!loginForm) return;
        formObserver.disconnect();
        loginForm.method = "GET";
        loginForm.action = "/pages/modulo-registrazione-b2b";
    });
    formObserver.observe(document.body, { childList: true, subtree: true });
    setTimeout(() => {
        formObserver.disconnect();
    }, 5000);
}
